import { StandardDonation } from '@domains';
import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './standard-donation.actions';

export interface StandardDonationState {
  standardDonations: Array<StandardDonation>;
  standardDonationsTotalCount: number;
  standardDonation: StandardDonation | null;
}

const initialState: StandardDonationState = {
  standardDonations: new Array<StandardDonation>(),
  standardDonationsTotalCount: 0,
  standardDonation: null,
};

const reducer = createReducer(
  initialState,
  on(fromActions.getStandardDonations, (state, { keep }) => ({
    ...state,
    standardDonations: keep === true ? state.standardDonations : [],
  })),
  on(fromActions.getStandardDonationsSuccess, (state, { resultsCount, results }) => ({
    ...state,
    standardDonationsTotalCount: resultsCount,
    standardDonations: results,
  })),
  on(fromActions.getStandardDonation, (state) => ({ ...state, standardDonation: null })),
  on(fromActions.getStandardDonationSuccess, (state, { standardDonation }) => ({ ...state, standardDonation })),
);

export function standardDonationReducer(state: StandardDonationState | undefined, action: Action) {
  return reducer(state, action);
}
